/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   Pins
 */

import type { PinsApiResponse, PinsBizo } from '@zcode/state-type'
import type { Mutable } from '@zcode/utility-types'
import Pin from '../../shared/bizos/pin'

export const DEFUALT_PINS = {
  pins: [],
  matching: 0,
}

const fromJS = (data: PinsApiResponse) => {
  const pins: Pick<PinsBizo, 'matching'> & Mutable<Pick<PinsBizo, 'pins'>> = {
    ...DEFUALT_PINS,
    matching: data.matching,
  }

  if (data.pins) {
    // @ts-expect-error Pin[] is not assignable to Array<Pin<RawPinInventorySearch>>
    pins.pins = data.pins.map((pin) => Pin.fromJS(pin))
  }

  return pins
}

// eslint-disable-next-line import/no-default-export,import/no-anonymous-default-export
export default { fromJS }
